import JsonLd from "@/components/JsonLd.tsx";

export default function JsonLdOrganizationSchema({routeId}: {
    routeId: string,
}) {
    return <JsonLd
        id={`page${routeId}/organization-schema`}
        item={{
            "@context": "https://schema.org",
            "@graph":   [
                {
                    "@type":        "Organization",
                    "@id":          "https://scorepal.co/#organization",
                    "name":         "ScorePal",
                    "url":          "https://scorepal.co/",
                    // Stable, non-hashed path so the logo survives every deploy (build-hashed
                    // /assets/* URLs change each build and would break this reference).
                    // TODO: swap for a dedicated high-res /logo.png when one is hosted.
                    "logo":         {
                        "@type": "ImageObject",
                        "url":   "https://scorepal.co/favicon-180x180.png"
                    },
                    "email":        "shaun@scorepal.co",
                    "telephone":    "+1 (260) 217-7119",
                    "address":      {
                        "@type":           "PostalAddress",
                        "streetAddress":   "2604 Whittier Place",
                        "addressLocality": "Wilmington",
                        "addressRegion":   "Delaware",
                        "postalCode":      "19808",
                        "addressCountry":  "US"
                    },
                    "contactPoint": {
                        "@type":             "ContactPoint",
                        "contactType":       "customer support",
                        "telephone":         "+1 (260) 217-7119",
                        "email":             "shaun@scorepal.co",
                        "availableLanguage": ["English"]
                    },
                    "founder":      {
                        "@type": "Person",
                        "name":  "Shaun Tidy"
                    },
                    "sameAs":       [
                        "https://www.linkedin.com/company/scorepal",
                        "https://play.google.com/store/apps/details?id=co.scorepal.mobile",
                        "https://apps.apple.com/us/app/score-pal/id6745509167"
                    ]
                },
                {
                    "@type":      "WebSite",
                    "@id":        "https://scorepal.co/#website",
                    "url":        "https://scorepal.co/",
                    "name":       "ScorePal",
                    "publisher":  {
                        "@id": "https://scorepal.co/#organization"
                    },
                    "inLanguage": "en"
                }
            ]
        }}
    />;
}
